<template>
  <div class="ws-modal">
    <form class="ws-modal__form" @submit.prevent="submit">
      <header class="ws-modal__header">
        <h2 class="has-text-weight-bold is-size-1">Загрузка новых кураторов и экспертов</h2>
      </header>
      <div class="ws-modal__content">
        <ws-participants-import
          format="xlsx"
          name="users"
          :isDragAndDrop="true"
          @input-users="inputUsers"
        >
        </ws-participants-import>
      </div>
    </form>
    <aside class="ws-modal__sidebar">
      <button class="ws-button button is-text"
              @click.prevent="close">
        <ws-icon
          class="ws-button__icon"
          name="close-thin"
          color="#000000"
          :fill="true"
          :title="$t('Закрыть')"
          width="17"
          height="18"
        />
      </button>
    </aside>
  </div>
</template>

<script>
export default {
  name: 'WsUserUpload',
  props: {

  },
  data () {
    return {

    }
  },
  watch: {

  },
  methods: {
    async inputUsers () {
      this.$buefy.toast.open({
        message: this.$t(`Пользователи успешно загружены`),
        type: 'is-success'
      })
      this.close()
    },
    close () {
      this.$parent.close()
    }
  }
}
</script>
